import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 400,
      fontSize: '12px',
      borderRadius: '15px',
      flex: 'none',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      '@media (max-width: 1025px)': {
        height: 'max-content',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'start',
        gap: '15px'
      }
    },
    empty: {
      background: palette.background.underBox
    },
    isOutText: {
      color: palette.danger.red
    },
    productActions: {
      display: 'flex',
      gap: '10px',
      '@media (max-width: 1025px)': {
        justifyContent: 'flex-end',
        width: '100%'
      },
      '@media (max-width: 500px)': {
        justifyContent: 'space-between'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
